<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-top-transition"
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        color="botao_1"
        class="mr-1"
        v-bind="attrs"
        v-on="on"
        small
        @click="set_form(usuario)"
        >mdi-pencil</v-icon
      >
    </template>

    <v-card class="rounded-lg">
      <v-toolbar dark class="rounded-lg" color="primary">
        Atualizar::{{ form.id }}
      </v-toolbar>

      <br />

      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model.trim="form.username"
            label="Usuário"
            :rules="[rules.obrigatorio]"
            :counter="50"
            :maxlength="50"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

          <v-text-field
            v-model.trim="form.email"
            label="E-mail"
            :rules="[rules.obrigatorio, rules.email]"
            :counter="50"
            :maxlength="50"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

          <v-row>
            <v-col>
              <v-checkbox
                v-model="form.is_staff"
                label="Desenvolvedor?"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                v-model="form.is_superuser"
                label="Admin?"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="form.is_active" label="Ativo?"></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="dialog = false"> Cancelar </v-btn>
        <v-btn text @click="salvar(form)"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from "vuex";

export default {
  name: "AtualizarUsuario",

  props: {
    usuario: Object,
  },

  data: () => ({
    dialog: false,
    formTitle: "Novo Lembrete",
    form: {},
    rules: {
      obrigatorio: (v) => !!v || "Este campo é obrigatório",
      email: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
    },
  }),

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    salvar(lembrete_alterado) {
      if (this.$refs.form.validate()) {
        this.CarregandoMutation();
        const headers = verifica_token_storage();

        api
          .put("admin/usuarios", lembrete_alterado, { headers })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            // Resetar
            this.dialog = false;
            this.form = {};
            this.CarregandoMutation();
          });
      }
    },

    set_form(usuario) {
      this.form = usuario;
    },
  },
};
</script>
